import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { HomeComponent } from './pages/home/home.component';
import { TiendaComponent } from './pages/tienda/tienda.component';
import { ZonasComponent } from './pages/zonas/zonas.component';
import { ProductoComponent } from './pages/producto/producto.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CarritoComponent } from './pages/carrito/carrito.component';
import { FinalizarComponent } from './pages/finalizar/finalizar.component';
import { LoaderInterceptor } from './auth/auth/loader-interceptor.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { EncryptionInterceptor } from './servicios/interceptors/encryption.interceptor';
import { DecryptionInterceptor } from './servicios/interceptors/decryption.interceptor';
import { AppInterceptorsService } from './auth/auth/app-interceptors.service';
import { LoginComponent } from './pages/espacio-mayoristas/login/login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TiendaComponent,
    ZonasComponent,
    ProductoComponent,
    CarritoComponent,
    FinalizarComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    ComponentsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: (environment as any).enableSw ?? environment.production }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorsService,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: EncryptionInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DecryptionInterceptor,
    //   multi: true,
    // },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
